import React, { useEffect, useState } from 'react';
import { servicios } from '../../json/servicios';
import './servicios.css';

const Servicios = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        setTimeout(() => setIsVisible(true), 100);
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <div>
                    <h3 className='title'>Servicios</h3>
                    <hr className='hr-gob'/>
                </div>
                {
                    servicios.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-12'>
                            <div className='card_container_historicos'>
                                <a 
                                    href={item.urlRuts} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className='card_anio'
                                >
                                    <h6>{item.descripcion}</h6>
                                </a>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Servicios;
